/**
 * Pure H OS · Phase D Wave 2 · Unified Timeline (types + live view).
 * MongoDB collection: `pureh_timeline`.
 */
import { liveArray } from "../services/store";

export type TimelineKind =
  | "decision" | "batch" | "campaign" | "milestone" | "payment"
  | "order" | "supplier" | "hire" | "insight";
export type TimelineSeverity = "low" | "medium" | "high";

export type TimelineEvent = {
  id: string;
  whenRelative: string;
  module: string;
  kind: TimelineKind;
  severity: TimelineSeverity;
  actor: string;
  event: string;
  detail: string;
  linkedTo?: string | null;
};

export const TIMELINE: TimelineEvent[] = liveArray<TimelineEvent>("timeline");
